import React, { useState } from "react";
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBars, faTimes
} from '@fortawesome/free-solid-svg-icons';


import AgeCalculator from "./calculators/AgeCalculator";
import AssignmentScoreCalculator from "./calculators/AssignmentScoreCalculator";
import AttendanceCalculator from "./calculators/AttendanceCalculator";
import BloomAnalysisCalculator from "./calculators/BloomAnalysisCalculator";

import ExamMarksDistributionCalculator from "./calculators/ExamMarksDistributionCalculator";
import ExamScoreCalculator from "./calculators/ExamScoreCalculator";
import ExamTimeCalculator from "./calculators/ExamTimeCalculator";
import GPACalculator from "./calculators/GPACalculator";
import GradeCalculator from "./calculators/GradeCalculator";
import HomeworkCompletionCalculator from "./calculators/HomeworkCompletionCalculator";
import LessonCoverageCalculator from "./calculators/LessonCoverageCalculator";
import LessonPlanCalculator from "./calculators/LessonPlanCalculator";
import LibraryBookDueDateCalculator from "./calculators/LibraryBookDueDateCalculator";
import OnlineClassBandwidthCalculator from "./calculators/OnlineClassBandwidthCalculator";
import OvertimePayCalculator from "./calculators/OvertimePayCalculator";
import ProfessionalDevelopmentTimeCalculator from "./calculators/ProfessionalDevelopmentTimeCalculator";
import RubricCalculator from "./calculators/RubricCalculator";
import SalaryBreakdownCalculator from "./calculators/SalaryBreakdownCalculator";
import SeatingCalculator from "./calculators/SeatingCalculator";
import StudentFeedbackAnalysisCalculator from "./calculators/StudentFeedbackAnalysisCalculator";
import SyllabusTracker from "./calculators/SyllabusTracker";
import TeachingHoursCalculator from "./calculators/TeachingHoursCalculator";
import WorkLifeBalanceCalculator from "./calculators/WorkLifeBalanceCalculator";

// Age Calculator - Computes Student Age
// Assignment Score Average Calculator - Computes average score from multiple assignments.
// Attendance Calculator - Finds attendance percentage.
// Bloom Calculator - Design better assessments, lesson plans, and learning objectives.
// Exam Paper Marks Distribution Calculator - Helps allocate marks for questions.
// Exam Score Percentage Calculator - Finds score percentage from total marks.
// Exam Time Management Calculator - Exam Time Management.
// GPA Calculator - Calculates cumulative GPA from subject grades.
// Grade Calculator - Computes final grades based on weighted scores.
// Homework Completion Percentage Calculator - Tracks percentage of completed homework.
// Lesson Coverage Progress Calculator - Measures syllabus completion.
// Lesson Plan Time Calculator - Helps plan lesson durations.
// Library Book Due Date Calculator - Finds return date based on issue date.
// Online Class Bandwidth Calculator - Estimates data usage for virtual classes.
// Overtime Pay Calculator - Calculates extra pay based on hours.
// Professional Development Hours Calculator - Tracks training hours attended.
// Rubric Calculator - Assign scores to different criteria and calculates the final grade based on predefined weightings.
// Salary Breakdown Calculator - Helps teachers split salary into savings, expenses, etc.
// Seating Arrangement Calculator - Determines seating layouts based on space.
// Student Feedback Analysis Calculator - Computes average feedback ratings.
// Student-Teacher Ratio Calculator - Computes ratio for a given class size.
// Teaching Hours Tracker - Logs teaching hours over a period.
// Work-Life Balance Score Calculator - Measures balance based on work and leisure time.


const DeepTeachCalculators = () => {
  const [selectedCalculator, setSelectedCalculator] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  // Calculator list
  const calculators = [
    { title: "Age", component: <AgeCalculator /> },
    { title: "Assignment Score Average", component: <AssignmentScoreCalculator /> },
    { title: "Attendance", component: <AttendanceCalculator /> },
    { title: "Bloom Aanlysis", component: <BloomAnalysisCalculator /> },
    { title: "Exam Marks Distribution", component: <ExamMarksDistributionCalculator /> },
    { title: "Exam Score", component: <ExamScoreCalculator /> },
    { title: "Exam Time Management", component: <ExamTimeCalculator /> },
    { title: "GPA", component: <GPACalculator /> },
    { title: "Grade Calculator", component: <GradeCalculator /> },
    { title: "Homework Completion", component: <HomeworkCompletionCalculator /> },
    { title: "Lesson Coverage", component: <LessonCoverageCalculator /> },
    { title: "Lesson Plan", component: <LessonPlanCalculator /> },
    { title: "Library Book Due Date", component: <LibraryBookDueDateCalculator /> },
    { title: "Online Class Bandwidth", component: <OnlineClassBandwidthCalculator /> },
    { title: "Overtime Pay", component: <OvertimePayCalculator /> },
    { title: "Professional Development Time", component: <ProfessionalDevelopmentTimeCalculator /> },
    { title: "Rubric", component: <RubricCalculator /> },
    { title: "Salary Breakdown", component: <SalaryBreakdownCalculator /> },
    { title: "Seating", component: <SeatingCalculator /> },
    { title: "Student Feedback Analysis", component: <StudentFeedbackAnalysisCalculator /> },
    { title: "Syllabus Tracker", component: <SyllabusTracker /> },
    { title: "Teaching Hours", component: <TeachingHoursCalculator /> },
    { title: "Worklife Balance Score", component: <WorkLifeBalanceCalculator /> },
  ];

  // Function to select a calculator & close any open divs
  const handleSelectCalculator = (index) => {
    setSelectedCalculator(calculators[index].component);
    setMenuOpen(false); // Close menu on mobile
  };

  return (
    <MainLayout>
        <div className="flex bg-gray-700">
            <div className={`w-64 bg-blue-700 text-white p-5 fixed h-full md:relative md:flex md:flex-col transition-all duration-300 ${menuOpen ? "left-0" : "-left-64"} md:left-0`}>
                <div className="flex justify-between items-center md:hidden">
                <h2 className="text-lg font-bold">Teacher Tools</h2>
                <FontAwesomeIcon icon={faTimes}  className="cursor-pointer text-xl" onClick={() => setMenuOpen(false)} />
                </div>
                <ul className="mt-1 space-y-1">
                {calculators.map((calc, index) => (
                    <li key={index} className="cursor-pointer p-2 rounded-lg hover:bg-blue-500" onClick={() => handleSelectCalculator(index)}>
                    {calc.title}
                    </li>
                ))}
                </ul>
            </div>

            <button className="md:hidden fixed top-5 left-5 text-2xl text-blue-700" onClick={() => setMenuOpen(true)}>
                <FontAwesomeIcon icon={faBars}/> 
            </button>

            <div className="flex-1 p-6 overflow-y-auto">
                {selectedCalculator ? (
                <div className="bg-gray-700 p-6 shadow-md rounded-lg mb-8">{selectedCalculator}</div>
                ) : (
                <div className="text-center text-xl text-yellow-200 items-center mt-24">Select a calculator from the menu</div>
                )}
            </div>
        </div>
    </MainLayout>
  );
};

export default DeepTeachCalculators;
